import * as React from 'react';

const ArrowLeftIcon = ({ width = 40, height = 40, stroke = '#ffffff', ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40" fill="none" {...props}>
        <path d="M31.5 20H8.5" stroke={stroke} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M20 8.5L8.5 20L20 31.5" stroke={stroke} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default ArrowLeftIcon;
